import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store';
import axios from 'axios';
//import vSelect from 'vue-select';
import {Vuetable ,VuetablePagination} from 'vuetable-2';
import JsonExcel from 'vue-json-excel/JsonExcel.vue';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone';  
//import 'date-input-polyfill';  
//import Popover  from 'vue-js-popover';
import VueCookies from 'vue-cookies';  
import BootstrapVue from 'bootstrap-vue'; 
import VeeValidate from 'vee-validate';
import { DatePickerPlugin ,DateRangePickerPlugin} from '@syncfusion/ej2-vue-calendars';  
import Element from 'element-ui';
import 'vue-search-select/dist/VueSearchSelect.css'

import iziToast from './lib/iziToastPlugin'; 
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';  
import VueCroppie from 'vue-croppie';

// import 'element-ui/lib/theme-chalk/reset.css'

//import DataTable from 'v-data-table';
//import Vuetify from "vuetify";
//import 'croppie/croppie_img.css'; // import the croppie css manually                           

//Vue.component('date-picker', DatePicker);
Vue.component('vuetable-pagination', VuetablePagination);
//Vue.use(Vuetable);
Vue.use(iziToast);

Vue.use(require('vue-moment'));
Vue.component('downloadExcel', JsonExcel);

Vue.use(VueCroppie);
//Vue.use(DataTable);
Vue.use(VeeValidate);
Vue.use(Element);

Vue.config.productionTip = false;
Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(DatePickerPlugin);
Vue.use(DateRangePickerPlugin);
Vue.prototype.$http = axios;
  
new Vue({
  router,
  store,
  render: (h) => h(App),
  created () {
    window.addEventListener('offline', () => {
      
      this['$iziToast'].error({
        overlay: true,
        timeout: 4000, 
        toastOnce: true,
        position: 'center',
        title:'No internet Connection',
        icon: '',
    });
     // store.dispatch('setConnected', false)
    })
    window.addEventListener('online', () => {
      //store.dispatch('setConnected', true)
    })
  }
}).$mount('#app');
